exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "section.content{\r\n    display: inline-block;\r\n    width:100%;\r\n}\r\nhtml,body{\r\n    height: 100% !important;\r\n  }\r\nhtml,body,.wrapper,.content-wrapper{\r\n    height:100%;\r\n}\r\nsection.content{\r\n    background-color: #ecf0f5;\r\n}\r\nfooter.footer{\r\n    position: absolute;\r\n    bottom:1em;\r\n    width: 100%;\r\n    color:#FFF;\r\n    text-align: center;\r\n  }\r\n@media (max-width: 767px){\r\n    .content-wrapper{\r\n        position: absolute;\r\n        width:100%;\r\n    }\r\n    footer.footer{\r\n        bottom:0;\r\n    }\r\n\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/assets/css/AngularAgentiWebCommon.css
// module id = ../../../../../src/assets/css/AngularAgentiWebCommon.css
// module chunks = main